<template>
  <div class="filter-location-types-container">
    <div class="location-types">
      <div
        v-for="type in locationTypes"
        :key="type.value"
        class="location-type"
      >
        <ElButton
          :type="type.selected ? 'primary active' : 'primary'"
          @click="selectedLocationType(type)"
        >
          <span>
            {{ type.label }}
          </span>
        </ElButton>
      </div>
    </div>
    <div class="actions">
      <ElButton type="link dark" @click="clear()">
        {{ $t('clear') }}
      </ElButton>
      <ElButton type="primary dark" @click="$emit('filter')">
        {{ $t('apply') }}
      </ElButton>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default defineComponent({
  setup() {
    const { width, height } = useBreakpoints()
    const { t } = useI18n()
    const { $sentry } = useNuxtApp()
    const router = useRouter()
    const route = useRoute()
    const config = useRuntimeConfig()

    const initialVariables = []

    let objectToReturn = {
      width,
      height,
      t,
      router,
      route,
      config,
      $sentry
    }
    for (const variable of initialVariables) {
      objectToReturn = Object.assign(objectToReturn, variable)
    }

    return objectToReturn
  },
  data() {
    return {
      locationTypes: getLocationTypes()
        .filter((i) => i.value.toLowerCase() !== 'place_of_interest')
        .map((i) => {
          return {
            value: i.value,
            label: this.$t(
              i.value.toLowerCase() === 'country'
                ? 'countries_plural'
                : i.value.toLowerCase() === 'city'
                ? 'cities'
                : `${i.value.toLowerCase()}s`
            ),
            selected: false
          }
        })
    }
  },
  methods: {
    selectedLocationType(type) {
      this.locationTypes = this.locationTypes.map((i) => {
        if (i.value === type.value) {
          return {
            ...i,
            selected: i.selected === false ? true : false
          }
        } else {
          return {
            ...i,
            selected: false
          }
        }
      })
      this.$emit(
        'selectedLocationType',
        this.locationTypes.find((i) => i.selected === true)?.value ?? null
      )
      this.$emit(
        'selectedLocationTypeLabel',
        this.locationTypes.find((i) => i.selected === true)?.label ?? null
      )
    },
    clear() {
      this.locationTypes = this.locationTypes.map((i) => {
        return {
          ...i,
          selected: false
        }
      })
      this.$emit('selectedLocationType', null)
      this.$emit('selectedLocationTypeLabel', null)
      this.$emit('filter')
    }
  }
})
</script>

<style scoped lang="scss">
.filter-location-types-container {
  max-height: 300px;
  padding-bottom: 10px;
  overflow-y: auto;
  .location-types {
    display: flex;
    flex-wrap: wrap;
    .location-type {
      margin: 0 8px 8px 0;
    }
  }
  .actions {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>